import { render, staticRenderFns } from "./CareSms.vue?vue&type=template&id=5ebffb25"
import script from "./CareSms.vue?vue&type=script&lang=js"
export * from "./CareSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports